var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "formValidate",
      attrs: { model: _vm.userDetail, "label-width": "180px" }
    },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.account"), prop: "loginName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userDetail.loginName,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "loginName", $$v)
                      },
                      expression: "userDetail.loginName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.userName"), prop: "name" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userDetail.name,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "name", $$v)
                      },
                      expression: "userDetail.name"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("user.department"), prop: "deptName" }
                },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userDetail.deptName,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "deptName", $$v)
                      },
                      expression: "userDetail.deptName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.role"), prop: "roleName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userDetail.roleName,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "roleName", $$v)
                      },
                      expression: "userDetail.roleName"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.email"), prop: "email" } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.emailFormat(_vm.userDetail.email),
                      disabled: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.phone"), prop: "phone" } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.phoneFormat(_vm.userDetail.phone),
                      disabled: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.nickName"), prop: "nickName" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.userDetail.nickName,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "nickName", $$v)
                      },
                      expression: "userDetail.nickName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.sex"), prop: "sex" } },
                [
                  _c("zk-dictionary-select", {
                    attrs: { type: "sex", disabled: "", clearable: "" },
                    model: {
                      value: _vm.userDetail.sex,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "sex", $$v)
                      },
                      expression: "userDetail.sex"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("user.status"), prop: "status" } },
                [
                  _c("zk-dictionary-select", {
                    attrs: { type: "status", disabled: "" },
                    model: {
                      value: _vm.userDetail.status,
                      callback: function($$v) {
                        _vm.$set(_vm.userDetail, "status", $$v)
                      },
                      expression: "userDetail.status"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("user.registerTime"),
                    prop: "createTime"
                  }
                },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.convertTime(_vm.userDetail.createTime),
                      disabled: ""
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26127cd7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26127cd7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/cdpBase/baseComponents/userDetail/src/main.vue
// module id = null
// module chunks = 